<template>
  <span></span>
</template>

<script>
export default {
  name: 'DummyComponent'
}
</script>

<style scoped></style>
